
$(document).ready(function() {
if($(".cateslider")){  
 $(".cateslider").owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  }); 
}  
}); 

$(document).ready(function() {
if($(".leftowner-image .owl-carousel")){  
 $(".leftowner-image .owl-carousel").owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    stagePadding: 0,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });
 }
}); 
  
function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}

//filters

// let checkBox = document.querySelectorAll('.filter-option');
// let products = document.querySelectorAll('.productNew');
// setTimeout(() => {
//   checkBox.forEach((div) => {
//     let checkBoxInput = div.querySelector('input[type="checkbox"]');

//     if (checkBoxInput) {
//       checkBoxInput.addEventListener('click', () => {
//         if (checkBoxInput.checked) {
//           console.log('Checkbox is checked!');
//           handleFilter();  // Execute your code when the checkbox is checked
//         } else {
//           console.log('Checkbox is unchecked!');
//           handleFilter();  // Optionally, execute something when unchecked
//         }
//       });
//     }
//   });
// }, 5000);  // Delay the execution by 5000ms (5 seconds)

// function handleFilter() {

//   console.log('Filtering products...');
// }

// let navigation = document.getElementById('nav');

// if (document.body.classList.contains('cart')) {
//   navigation.style.display = 'none';
// }





// function updateStockStatus(selectElement) {
  
//   var selectedOption = selectElement.options[selectElement.selectedIndex];

//   // Get the inventory quantity for the selected variant
//   var inventoryQuantity = selectedOption.getAttribute('data-inventory');
//       console.log(inventoryQuantity);
//   // Get the stock status element
//   var stockStatusElement = document.getElementById('stock-status');

//   // Check if inventory is less than 1
//   if (parseInt(inventoryQuantity) < 1) {
//     stockStatusElement.innerHTML = '<span class="red-circle"></span> Out of Stock';
//   } else {
//     stockStatusElement.innerHTML = '<span class="green-circle"></span> In Stock';
//   }
// }

// const selectBoxes = document.querySelectorAll ('.multi_select');
// selectBoxes.foreach(box => {
//   const options  = box.queryselectorALl('option')
//   selectBoxes.foreach(option => {
//     option.addEventlistener('click', fucntion (evt) {
//       console.log(evt.TARGET);
//     })
    
//   })
// })




document.addEventListener('DOMContentLoaded', function () {
  function destroySwiper(swiper) {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  }

  function generateUniqueId() {
    return 'swiper-' + Math.random().toString(36).substr(2, 9);
  }

  function initSwiper(slider) {
    var desktopColumns = parseInt(slider.getAttribute('desktop-column'));
    var tabletColumns = parseInt(slider.getAttribute('tablet-column'));
    var mobileColumns = parseInt(slider.getAttribute('mobile-column'));
    var enablePagination = slider.getAttribute('pagination');
    var enableArrows = slider.getAttribute('arrows');
    var enableScrollbar = slider.getAttribute('scrollbar');
    var enableAutoplay = slider.getAttribute('autoplay') === 'true';
    var autoplayDelay = parseInt(slider.getAttribute('slider-delay'));
    var enableLoop = slider.getAttribute('loop') === 'true';
    var sliderSpaceBetween = parseInt(slider.getAttribute('slider-space-between'));

    var paginationId = generateUniqueId();
    var nextArrowId = generateUniqueId();
    var prevArrowId = generateUniqueId();
    var scrollbarId = generateUniqueId();

    var paginationEl = slider.querySelector('.swiper-pagination');
    var nextArrowEl = slider.querySelector('.swiper-button-next');
    var prevArrowEl = slider.querySelector('.swiper-button-prev');
    var scrollbarEl = slider.querySelector('.swiper-scrollbar');

    if (enablePagination && paginationEl) {
      paginationEl.id = paginationId;
    }
    if (enableArrows && nextArrowEl && prevArrowEl) {
      nextArrowEl.id = nextArrowId;
      prevArrowEl.id = prevArrowId;
    }
    if (enableScrollbar && scrollbarEl) {
      scrollbarEl.id = scrollbarId;
    }

    return new Swiper(slider, {
      slidesPerView: mobileColumns,
      spaceBetween: sliderSpaceBetween,
      pagination: enablePagination && paginationEl ? { el: `#${paginationId}`, clickable: true } : false,
      navigation: enableArrows && nextArrowEl && prevArrowEl ? {
        nextEl: `#${nextArrowId}`,
        prevEl: `#${prevArrowId}`,
      } : false,
      scrollbar: enableScrollbar && scrollbarEl ? { el: `#${scrollbarId}`, draggable: true } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      loop: enableLoop,
      breakpoints: {
        1025: {
          slidesPerView: desktopColumns,
        },
        768: {
          slidesPerView: tabletColumns,
        },
      },
    });
  }

  function loadSliders() {
    var sections = document.querySelectorAll('[id^="section-"]');
    
    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('.swiper-desktop-and-mobile, .swiper-desktop, .swiper-mobile');
      
      sliders.forEach(function (slider) {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var currentSwiper = slider.swiper;

        destroySwiper(currentSwiper);

        if (
          (slider.classList.contains('swiper-desktop-and-mobile')) ||
          (slider.classList.contains('swiper-desktop') && isDesktop) ||
          (slider.classList.contains('swiper-mobile') && isMobile)
        ) {
          slider.swiper = initSwiper(slider);
        }
      });
    });
  }

  function resizeSliders() {
    window.addEventListener('resize', function () {
      loadSliders();
    });
  }

  loadSliders();
  resizeSliders();
});





document.addEventListener('DOMContentLoaded', function() {
  const occasionsSlider = new Swiper('.occasions-slider', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 3.7
      }
    }
  });
}); 


document.addEventListener('DOMContentLoaded', function() {
  const occasionsSliders = document.querySelectorAll('.popular-products-slider');
  occasionsSliders.forEach(function(slider) {
    new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 17,
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  let radioButtons = document.querySelectorAll('.size-selector input[type="radio"]');
  let defaultPriceElement = document.querySelector('.product_section .modal_price__main .current_price');
  let comparePriceElement = document.querySelector('.product_section .modal_price__main .was_price'); 
  radioButtons.forEach(function(radio) {
    radio.addEventListener('change', function() {
      const variantId = radio.value;
      let labelElement = radio.nextElementSibling;
      let variantPrice = labelElement.getAttribute('data-price');
      let comparePrice = labelElement.getAttribute('data-compare-price');
      const hiddenInput = document.querySelector('.purchase-details__buttons input[name="id"]');
      hiddenInput.value = variantId;
      if (defaultPriceElement && variantPrice) {
        defaultPriceElement.querySelector('.money').innerHTML = variantPrice;
      }
      if (comparePriceElement && comparePrice) {
        comparePriceElement.querySelector('.money').innerHTML = comparePrice;
      }
    });
  });
});

/*============ change inventory message on PDP ============*/
document.addEventListener('DOMContentLoaded', function() {
  const radioButtons = document.querySelectorAll('.variant-selects input[type="radio"]');
  const stockMessageEl = document.querySelector('.instock-message');
  const inStockContentEl = document.querySelector('.instock-content span:first-child');
  const itemsLeftEl = document.querySelector('.instock-material .items_left');
  const atcButton = document.querySelector('.shopify-product-form button.ajax-submit');

  radioButtons.forEach(function(radio) {
    radio.addEventListener('change', function() {
      const variantId = this.value;
      const variant = document.querySelector(`.stock-messages input[data-id="${variantId}"]`);
      const stockMessage = variant?.getAttribute('data-message');
      if (!stockMessage) return;
      const isSoldOut = stockMessage === 'Out of stock';
      stockMessageEl.textContent = stockMessage;
      inStockContentEl.classList.toggle('gray-light', isSoldOut);
      inStockContentEl.classList.toggle('green-light', !isSoldOut);
      
      if (itemsLeftEl) {
        itemsLeftEl.classList.toggle('hidden', isSoldOut);
      }
      if (atcButton) {
        atcButton.disabled = isSoldOut;
        atcButton.classList.toggle('disabled', isSoldOut);
         if (isSoldOut) {
          atcButton.querySelector('.text').textContent = 'Out of Stock';
        } else {
          atcButton.querySelector('.text').textContent = 'Add to Cart';
        }
      }
    });
  });
});


window.updateQuantity =  function (variantId) {
  const variant = document.querySelector(`.stock-messages input[data-id="${variantId}"]`);
  const inventoryQuantity = variant?.getAttribute('data-quantity');
  const itemLeftCount = document.querySelectorAll('.item-left-count');
  const itemLefttext = document.querySelector('.item-left-text');
  
  if (inventoryQuantity && itemLeftCount.length > 0) {
    itemLeftCount.forEach(function(item) {
      item.textContent = inventoryQuantity;
    });
    if (inventoryQuantity == 1) {
      itemLefttext.textContent = 'item left';
    } else {
      itemLefttext.textContent = 'items left';
    }
  }
}

// ------ Collection top description read more functionality ---------
document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.toggle-read-more');
  const moreText = document.querySelector('.more-text');
  const ellipsis = document.querySelector('.ellipsis');

  if (toggleBtn && moreText) {
    toggleBtn.addEventListener('click', function () {
      if (moreText.style.display === 'none') {
        moreText.style.display = 'inline';
        ellipsis.style.display = 'none';
        toggleBtn.textContent = 'Read less';
      } else {
        moreText.style.display = 'none';
        ellipsis.style.display = 'inline';
        toggleBtn.textContent = 'Read more';
      }
    });
  }
});